import { Link } from '../shared/PrivateLink/ServerLink';
import { useTranslations } from 'next-intl';
import { LoginVaryLink } from '../shared/LoginVaryLink/LoginVaryLink';
import { Suspense } from 'react';

export const SupportLink = () => {
  const t = useTranslations('controls');
  return (
    <Suspense
      fallback={
        <Link href={'/support'} className='text-text-primary-day transition-colors hover:text-primary-green-day'>
          {t('footer.support')}
        </Link>
      }
    >
      <LoginVaryLink
        linkClassName='text-text-primary-day transition-colors hover:text-primary-green-day'
        loginedLink={'/my/support'}
        unLoginedLink='/support'
      >
        {t('footer.support')}
      </LoginVaryLink>
    </Suspense>
  );
};
